import { render, staticRenderFns } from "./urlConfig.vue?vue&type=template&id=0374a4fe&"
import script from "./urlConfig.vue?vue&type=script&lang=js&"
export * from "./urlConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports